'use client';

import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const ToastProvider = () => <ToastContainer position="top-center" autoClose={2500} transition={Slide} hideProgressBar pauseOnFocusLoss={false} theme="colored" stacked data-sentry-element="ToastContainer" data-sentry-component="ToastProvider" data-sentry-source-file="ToastProvider.tsx" />;